import {
    DEFAULT_MEASURE_AGGREGATION,
    MEASURE_AGGREGATIONS
} from '../models/pipeline/steps/dataset/aggregations';
import {IS} from '../models/pipeline/steps/dataset/filter_types';
import {ATTRIBUTES, MENUS, createDatasetAttribute, QUERY_BUILDER_TYPES} from '../utils/query_utils';
import {FEATURE_FLAGS} from './feature_flags';
import {globalClickEvent} from './global_events';
import {queryBuilderState, resetState} from './query_builder_state';
import EventGroup from './event_group';

export const inputFocusEvent = new EventGroup(
    'focus-input',
    (inputRef, menu, attribute, prop) => {
        Object.assign(queryBuilderState, {
            inputRef,
            menu,
            attribute,
            prop,
            searchQuery: inputRef.value || '',
        });
    },
    () => { inputChangeEvent.emit(queryBuilderState.searchQuery); }
);
export const inputChangeEvent = new EventGroup('input-change', (searchQuery) => {
    queryBuilderState.searchQuery = searchQuery;
});
export const inputSubmitEvent = new EventGroup('submit-input');
export const inputCancelEvent = new EventGroup('cancel-input', undefined, () => {
    inputBlurEvent.emit();
});
export const inputBlurEvent = new EventGroup('blur-input', () => {
    if (queryBuilderState.inputRef) {
        queryBuilderState.inputRef.blur();
    }
    resetState();
});

export const arrowDownEvent = new EventGroup('input-arrow-down');
export const arrowUpEvent = new EventGroup('input-arrow-up');

export const columnHoverEvent = new EventGroup('column-hover');
export const columnLeaveEvent = new EventGroup('column-blur');
export const columnSelectEvent = new EventGroup('select-column', (column) => {
    let type = queryBuilderState.attribute.type;
    if (type === ATTRIBUTES.COLUMN) {
        type = column.type === 'number' ? ATTRIBUTES.MEASURE : ATTRIBUTES.DIMENSION;
    }
    const attribute = createDatasetAttribute(type, undefined, queryBuilderState.attribute);
    const hadColumn = !!attribute.column;
    attribute.setColumn(column);
    if (type === ATTRIBUTES.MEASURE && !MEASURE_AGGREGATIONS[attribute.column.type].includes(attribute.aggregation)) {
        let agg = DEFAULT_MEASURE_AGGREGATION[attribute.column.type];
        if (column.pk) {
            agg = DEFAULT_MEASURE_AGGREGATION.pk;
        }
        attribute.setAggregation(agg);
    } else if (type === ATTRIBUTES.FILTER && !attribute.operator) {
        attribute.setOperator(IS);
    }
    queryBuilderState.attribute = attribute;
    queryBuilderState.searchQuery = '';
    return [attribute, hadColumn];
});
export const aggregationSelectEvent = new EventGroup('select-agg', (aggregation, column) => {
    const attribute = createDatasetAttribute(aggregation.type, undefined, queryBuilderState.attribute);
    const hadAggregation = !!attribute.aggregation;
    attribute.setColumn(column);
    attribute.setAggregation(aggregation);
    queryBuilderState.attribute = attribute;
    queryBuilderState.searchQuery = '';
    return [attribute, hadAggregation];
});
export const filterOperatorHoverEvent = new EventGroup('filter-op-hover');
export const filterOperatorLeaveEvent = new EventGroup('filter-op-leave');
export const filterOperatorSelectEvent = new EventGroup('select-filter-op', (operator) => {
    if (!operator) {
        return false;
    }
    const attribute = createDatasetAttribute(ATTRIBUTES.FILTER, undefined, queryBuilderState.attribute);
    const hadOperator = !!attribute.operator;
    attribute.setOperator(operator);
    queryBuilderState.attribute = attribute;
    queryBuilderState.searchQuery = '';
    return [attribute, hadOperator];
});
export const filterValueSelectEvent = new EventGroup('select-filter-value', (value) => {
    const attribute = createDatasetAttribute(ATTRIBUTES.FILTER, undefined, queryBuilderState.attribute);
    const hadOperator = !!attribute.operator;
    attribute.setValues([value]);
    queryBuilderState.attribute = attribute;
    queryBuilderState.searchQuery = '';
    return [attribute, hadOperator];
});

export const attributeRemoveEvent = new EventGroup('attribute-remove', () => {
    resetState();
});

export const nextMenuEvent = new EventGroup('next-menu', () => {
    const nextMenu = queryBuilderState.getNextMenu();
    if (FEATURE_FLAGS.QUERY_BUILDER_TYPE === QUERY_BUILDER_TYPES.COLUMN_FIRST && [MENUS.COLUMN, MENUS.AGGREGATION].includes(nextMenu)) {
        inputBlurEvent.emit();
        return false;
    }

    if ([MENUS.COLUMN, MENUS.COLUMN_AND_AGG].includes(nextMenu)) {
        inputBlurEvent.emit();
        return false;
    } else {
        queryBuilderState.menu = nextMenu;
    }
});
export const focusNewAttributeEvent = new EventGroup('focus-new-attr');

export const columnActionEvent = new EventGroup('column-action', undefined, () => {
    globalClickEvent.emit();
});
export const tableActionEvent = new EventGroup('table-action');
